import React, { Component } from 'react';
import {
    Button,
    Label,
    Input,
    FormGroup,
    Form,
    Alert,
    NavLink
} from 'reactstrap';
import PropTypes from 'prop-types';
import './Login.css';
import {Link} from "react-router-dom";
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";

import {Redirect} from 'react-router-dom';
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import TwoFALoginModal from './twoFALoginModal/TwoFALoginModal.container';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            registerApplicant: false
        };
    }

    componentWillUnmount() {
        this.props.onUnmount()
    }

    render() {
        if (this.state.registerApplicant) {
            return <Redirect to='/account-creation' push/>
        }

        return (
            <div className="login-container">
                <div className="login-form">
                    <Form onSubmit={this.onLogIn}>
                        <h4 className="text-center">{_.get(this.props.translation, 'login.label')}</h4>
                        <FormGroup>
                            <Label for="login-email">{_.get(this.props.translation, sharedLabelsPath.email_label)}</Label>
                            <Input type="email"
                                   value={this.state.email}
                                   onChange={this.handleEmailChange}
                                   required
                                   placeholder={_.get(this.props.translation, sharedLabelsPath.email_label)} />
                        </FormGroup>
                        <FormGroup>
                            <Label for="login-password">{_.get(this.props.translation, sharedLabelsPath.password_label)}</Label>
                            <Input type="password"
                                   value={this.state.password}
                                   onChange={this.handlePasswordChange}
                                   required
                                   placeholder={_.get(this.props.translation, sharedLabelsPath.password_label)} />
                        </FormGroup>
                        <Button type="submit" block className="olive-green-btn">{_.get(this.props.translation, 'login.login_button')}</Button>
                    </Form>
                    <div className="other-abilities-account-container">
                        <NavLink className="forgot-password-nav-link" tag={Link} to="/login/restore" onClick={this.handlePasswordReset}>{_.get(this.props.translation, 'login.forgot_password_label')}</NavLink>
                         <div className="create-new-account-container">
                            {_.get(this.props.translation, 'login.haven_t_account_label') + " "}
                            <FormWrapper successMessage={_.get(this.props.translation, 'register_applicant.success_message')}>
                                <Button className='applicant-registration-button' color="link" onClick={this.handleRegisterApplicantClick}>{_.get(this.props.translation, 'login.create_it_now_label')}</Button>
                            </FormWrapper>
                        </div>
                    </div>
                </div>
                <Alert color="warning" className="fetching-label" hidden={!this.props.fetching || this.props.is2FARequired}>
                    {_.get(this.props.translation, sharedLabelsPath.fetching_message)}
                </Alert>
                <Alert color="danger" className="error-label" hidden={!this.props.error || this.props.is2FARequired}>
                    {_.get(this.props.translation, sharedLabelsPath.errors)[this.props.error] || _.get(this.props.translation, sharedLabelsPath.defaultError)}
                </Alert>
                <TwoFALoginModal onSubmit={this.onLogInWithVerification}/>
            </div>
        );
    }

    handleEmailChange = (e) => {
        this.setState({ email: e.target.value });
    };

    handlePasswordChange = (e) => {
        this.setState({ password: e.target.value });
    };

    handlePasswordReset = () => {
        this.props.onForgotPassword(this.state.email);
    };

    onLogIn = (e) => {
        e.preventDefault();

        let data = {
            'username': this.state.email,
            'password': this.state.password,
        };

        this.props.onLogIn(data);
    };

    onLogInWithVerification = (verificationCode) => {
        let data = {
            'username': this.state.email,
            'password': this.state.password,
            'totpcode': verificationCode
        };

        this.props.onLogIn(data);
    };

    handleRegisterApplicantClick = () => {
        this.setState({registerApplicant: true});
    };
}

Login.propTypes = {
    error: PropTypes.string,
    fetching: PropTypes.bool.isRequired,
    is2FARequired: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onLogIn: PropTypes.func.isRequired,
    onUnmount: PropTypes.func.isRequired
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/accountManagement/login/Login.js